import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import { useRedirect } from '../functions/context';
import { validateToken } from '../functions/validate';
import { getUserByEmail } from '../axios/user';
import { useEffect } from 'react';
import { useConfigContext } from '../functions/ConfigContext';

import {
    sessionService,
    ValidationUtility,
} from '../components/ComponentsLibrary';

const Landing = () => {
    const navigate = useNavigate();
    const { redirecting, } = useRedirect();
    const { configLibrary } = useConfigContext();

    const tokenValidate = async () => {
       
        // debugger;
        let config = {}
        if (!redirecting) {
           ValidationUtility.ValidateTokenFromIDP(configLibrary, navigate);
        }
      
    }

     useEffect(() => {
       
        if (!redirecting) {
            tokenValidate();  // TO-DO: Modify Code - Uncomment before Deployment
        }
       
    }, []); 
}

export default Landing;